<template>
  <ChapterComponent :opened="opened" :number="8" illustration="8/1.jpg">
    <div class="chapter__header-texts" slot="header_texts">
      <div class="chapter__number">VIII</div>
      <div class="chapter__author">Автор Тихон Шаров</div>
      <div class="chapter__headline">Там, где живут мечты</div>
      <div class="chapter__inner">
        <div class="chapter__description">
          <div class="chapter__description__inner">
           — Ты слышишь этот звук, Градарк? Откуда-то из глубины темного, беззвездного неба доносился зловещий рев. Еще час назад багровые лучи закатного солнца озаряли величественные виды Дикой долины<span class="chapter__description__not-opened-text">...</span><span class="chapter__description__opened-text">. Сейчас, в дрожащем свете факелов, за каждым камнем мерещилось чудище, готовое наброситься на двух одиноких всадников.<br>
            — Слышу, Регул. <br>
            — Монахи были правы. Даже по секретной тропе нельзя пройти через Долину незамеченными.</span>
          </div>
        </div>
        <div class="chapter__mobile-illustration" :style="{backgroundImage: `url(${require(`../../assets/illustrations/8/1.jpg`)})`}"></div>
        <div class="chapter__buttons">
          <a class="button" v-if="!opened" @click="opened = true" v-ga.click="$ga.commands.click.bind(this,'internal', 'click', 'open_chapter_8')">Открыть главу</a>
          <div v-else class="chapter__read-more">
            <div class="chapter__read-more__text">Читать далее</div>
            <svg  class="chapter__read-more__arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 110.2" style="enable-background:new 0 0 26 110.2;" xml:space="preserve">>
              <path class="st0" d="M21.9,65c-2,5-4,10.1-6,15.1C15,55.7,14.2,31.2,13.4,6.8c0-1.2-4.7-0.8-4.6,0.5c0.8,26.5,1.7,53,2.7,79.6 c-2-5.3-4.1-10.7-6.1-16c-0.5-1.3-5-0.5-4.6,0.5L12,102.1c0.4,1,3.3,0.9,4.3,0.1c0.3-0.2,0.6-0.4,0.7-0.6 c3.2-12.2,6.3-24.4,9.5-36.6C26.8,63.6,22.3,63.9,21.9,65"/>
            </svg>
          </div>
          <Listen :chapter="8" :opened="opened" />
        </div>
      </div>
    </div>
    <div slot="main" class="chapter__main" v-if="opened">
      <div class="chapter__texts">
        <Paragraph class="chapter__paragraph chapter__paragraph--1">
          <div class="person">
            <div class="person__inner">
              <img class="person__photo" src="@/assets/illustrations/8/photo.png"/>
              <div class="person__name">Дэн Волобуев</div>
              <div class="person__age">15 лет</div>
              <div class="person__info">
                Учащийся лицея, начинающий скейтер
              </div>
              <div class="person__location">
                Корпус Adagio, 5-й этаж
              </div>
              <MapToggle/>
            </div>
          </div>
          <p>— Но мы еще можем успеть найти убежище!</p>
          <Listen :chapter="8" class="listen--mobile-only" />
          <p>— Спастись от Чернодемона невозможно. Всех, кто пытался укрыться в пещерах, он испепелил заживо. Мы примем бой здесь. </p>
          <p>Рыцари спешились рядом с огромным валуном. Опытный воитель Градарк, в темных доспехах с алой молнией, украшающей нагрудник, излучал властное спокойствие. Однако по лицу его молодого помощника, облаченного в серебряные латы, пробежала тень тревоги. Нечеловеческий рев, раздирающий ночное пространство, неуклонно приближался. </p>
          <p>— Помни, Регул, нас бережет магия Хранителей. Свет древней мудрости не даст нам бесславно сгинуть в огне. А если придется пожертвовать жизнью, мы сделаем это во имя наших собратьев. </p>
          <p>Старший воин поднял свой арбалет и приладил стрелу с мерцающим наконечником. </p>
          <p>— Он совсем рядом, — прошептал Регул. </p>
          <p>В небе начали проявляться смутные очертания монстра. Его огромные крылья развевались, словно черные знамена, а воинственный рык нестерпимо терзал слух. </p>
          <p>— Он здесь! Убей его, Градарк! </p>
          <p> — Еще не время…</p>
          <p>Ослепительный столб огня, вырвавшийся из пасти дракона, осветил его исполинское туловище, и в то же мгновение волшебная стрела рассекла воздух.</p>
          <p>— Саша! Саша! </p>
          <p>Мальчик опустил самодельный арбалет и обернулся. Да это же <router-link @click.native="$ga.event('internal','click', 'open_chapter_5')" to="/chapters/5" class="chapter__link">сосед Денис, местная звезда скейтборда!</router-link> Гонец из реального мира насмешливо подмигнул двум раскрасневшимся пятиклассникам. </p>
          <p>— Ну что, рыцари, опять заигрались? Саня, я вижу, у вас тут битва в самом разгаре, но тебя мама зовет обедать. В общем, дуй домой. </p>
          <p>— Спасибо, Дэн. У меня, наверное, телефон разрядился. </p>
          <p>Но Дэн уже бодро ехал на доске в сторону скейт-парка. Саша сокрушенно вздохнул и толкнул в плечо лучшего друга Ромку, также известного как Регул.</p>
          <p>— Ладно, все на сегодня. Надо расходиться. </p>
          <p>— Блин, опять в самый интересный момент! </p>
          <p>Друзья начали собирать в рюкзаки нехитрое снаряжение: пластиковые доспехи, рисованные карты, деревянные мечи. Но прежде чем отправиться домой, Саша еще раз окинул взглядом любимую площадку и вместо качелей, горок и песочниц увидел причудливые замки, отвесные скалы и опасных созданий Дикой долины — зачарованного места, где его фантазии навсегда останутся настоящими.</p>
        </Paragraph>

      </div>
      <div class="plan">
        <div class="plan__header">
          Место счастья
        </div>
        <div class="plan__main">
          <div class="plan__background"></div>
          <img src="@/assets/illustrations/8/2.jpg" class="plan__photo"/>
          <div class="plan__description">
            <div class="plan__description__text">В «Фили Сити» детские игровые пространства спланированы так, чтобы каждый ребенок нашел себе занятия по возрасту — здесь не будет скучно ни малышам, ни подросткам. Планировка детского комплекса рассчитана на то, чтобы они не мешали друг другу.</div>
            <a target="_blank" href="https://filicity.ru/?utm_source=article&utm_campaign=june19&utm_medium=banner&utm_content=8" class="button"  v-ga.click="$ga.commands.click.bind(this,'external', 'click', 'chapter_8_podrobnee')">Подробнее</a>
          </div>
        </div>
      </div>
    </div>
  </ChapterComponent>
</template>
<style lang="stylus" scoped>
  @import "~@/assets/styles/sizes.styl";
  .chapter
    &__next
      padding vw(60, $desktop) 0 vw(80, $desktop)
    &__paragraph
      &--1
        padding-top vw(40, $desktop)
        margin-left vw(200, $desktop)
        width vw(500, $desktop)
        margin-bottom vw(70, $desktop)
        .person
          top vw(160, $desktop)
          right vw(-270, $desktop)
          &__photo
            width vw(130, $desktop)
            position relative
            left vw(-20, $desktop)
  .plan
    padding-bottom vw(160, $desktop)
    &__description
      top vw(240, $desktop)
    &__background
      +mobile()
        height vw(300, $mobile)
  .plan__mrgroup-logo
    bottom 0
    left: vw(50, $desktop)
    position: absolute;
    img
      height vw(20, $desktop)
      +mobile()
        height: vw(20, $mobile)
    +mobile()
        bottom: vw(-30, $mobile)
        left: vw(20, $mobile)
</style>
<script>
    import ChapterComponent from '@/components/ChapterComponent';
    import Paragraph from '@/components/Paragraph';
    import Listen from '@/components/Listen';
    import MapToggle from '@/components/MapToggle';
    export default {
        components: {
            Paragraph,
            Listen,
            MapToggle,
            ChapterComponent
        },
      data() {
          return {
              opened: !!this.$route.query.opened || false
          }
      }
  }
</script>